<template>
  <div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows">
    </el-pagination>
  </div>
</template>

<script>
import tableMixins from './mixins/tableMixins.js';
export default {
  mixins: [tableMixins],
  props: {
    page: { // 表格数据
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      
      
    };
  },
  filters: {
    approveType(val) {
      let objStr = {
        Y: '合格',
        N: '不合格',
        P: '部分合格',
      };
      return objStr[val] || '-';
    },
    tenantApproveType(val) {
      let objStr = {
        Y: '满意',
        N: '不满意',
      };
      return objStr[val] || '-';
    },
  },
  watch: {
    dialogVisible(val) {
      // 监听原因说明弹框
      if (val) {
        this.issuesDesc = '';
      }
    },
    approvalState(val) {
      // 监听审核状态
      this.disabledInput = false;
      this.issuesDesc = '';
      this.checkedIssues = [];
      if (val=='N') {
        this.disabledInput = true;
      }
    },
    checkedIssues: {
      handler(newVal, oldVal) {
        console.log('kk',newVal, oldVal);
        
        if (newVal && newVal.length) {
          this.disabledInput = false;
        } else if(this.approvalState!='Y'){
          this.disabledInput = true;
        }
        this.checkedIssuesChange(newVal, oldVal);
        if (this.approvalState === 'Y' && newVal.length === 0) {
          this.issuesDesc = '';
        }
      },
    },
  },
  created() {
    
    
  },
  beforeDestroy() {
    
  },
  methods: {
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.$emit('getData');
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.$emit('getData');
    },
   
  },
};
</script>

<style lang="less" scoped>
.el-timeline-item {
  // padding-bottom: 0px;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
// .dialog-title {
//   text-align: left;
//   width: 240px;
//   height: 27px;
//   font-family: PingFang SC;
//   font-size: 18px;
//   color: #212121;
//   letter-spacing: 0;
//   line-height: 27px;
//   font-weight: 400;
// }
// .operte-btns {
//   text-align: right;
//   border-top: 1px solid #d9d9d9;
//   background: #fff;
//   margin-top: 4px;
//   display: flex;
//   justify-content: center;
//   padding: 15px 0;
// }
// .operte-btns .btn {
//   padding: 5px 18px;
//   border: 1px solid rgba(217, 217, 217, 1);
//   border-radius: 2px;
//   cursor: pointer;
//   margin-right: 10px;
// }
// .approve-history {
//   max-height: 500px;
//   overflow-y: auto;
//   padding-right: 20px;
//   .reason-text {
//     color: #7f7f7f;
//   }
// }
// .good-file {
//   max-height: 700px;
//   overflow-y: auto;
//   padding-right: 20px;
// }
  .dialog-title {
    text-align: left;
    width: 240px;
    height: 27px;
    font-family: PingFang SC;
    font-size: 18px;
    color: #212121;
    letter-spacing: 0;
    line-height: 27px;
    font-weight: 400;
  }
  .audit-title{
    text-align: left;
    width: 240px;
    height: 27px;
    font-family: PingFang SC;
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
    line-height: 27px;
    font-weight: 600;
  }
  .dialogCon {
    border-top: 1px solid #dcdee0;
    text-align: left;
    padding: 10px 20px;
    .label{
      margin-right: 10px;
      line-height: 40px
    }
  }
  .moreInfoCon {
    .label{
      width:135px
    }
  }
  .dialogCon /deep/ .el-checkbox {
    padding: 0 14px;
    width: 40%;
    // height: 40px;
    // line-height: 40px;
    .el-checkbox__label {
      color: #212121;
    }
  }
  .dialogCon .dialogCon-checkbox /deep/ .el-checkbox-group {
    display: block;
  }
  .dialogCon .dialogCon-checkbox {
    max-height: 400px;
    overflow-y: auto;
    /deep/.el-form-item__content {
      line-height: 25px;
    }
    /deep/.el-form-item {
      margin-bottom: 0px;
    }
  }
  .dialogCon-checkbox-type {
    width: 100%;
  }
  .type-check-list {
    margin-top: 4px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .type-check-item {
    width: 50%;
  }
</style>
